
import Vue from "vue";

export default Vue.extend({
	data(){
		return {
			links: [] as {url:string, name:string}[]
		};
	},
	props: {
		value: {
			type: [Object as ()=>File, Array as ()=>File[], File],
			default: ()=>[]
		},
		disableRemove: Boolean
	},
	computed: {
		files():File[]{
			if (Array.isArray(this.value)){
				return this.value;
			}
			return [this.value];
		}
	},
	watch: {
		files: {
			immediate: true,
			handler(){
				for (let link of this.links){
					URL.revokeObjectURL(link.url);
				}
				this.links = [];
				for (let file of this.files){
					this.links.push({url: URL.createObjectURL(file), name: file.name});
				}
			}
		}
	},
	methods: {
		remove(i:number){
			if (Array.isArray(this.value)){
				this.$emit("remove", i);
			}else{
				this.$emit("remove");
			}
		}
	},
	destroyed(){
		for (let link of this.links){
			URL.revokeObjectURL(link.url);
		}
	}
});
